<template>
  <div class="seomain">
    <!-- <ul class="tab-tilte four">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul> -->
    <div class="tab-content tab-content-list">
      <div class="st-list-box pan-3">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">工单号：{{ v.code }}</div>
            </div>
            <div class="st-list-main">
              <!-- <p>工单号：{{ v.code }}</p> -->
              <p>国家：{{ v.country }}</p>
              <p>城市：{{ v.city }}</p>
              <p>供应商：{{ v.supplier_name }}</p>
              <p>地址：{{ v.address }}</p>
              <p>联系人：{{ v.contact }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>派单编号：{{ v.dispatchorder }}</p>
              <p>派单日期：{{ v.dispatchtime }}</p>
              <p>数量：{{ v.quantity }}</p>
              <p>机房：{{ v.engineroom }}</p>
              <p>预约日期：{{ v.reservationdate }}</p>
              <p>提货人：{{ v.picker_name }}</p>
              <p @click="popupShowHandle(0)">实际到库日期：{{ v.actualdeliverydate }}</p>
              <p @click="popupShowHandle(1)">预计到库日期：{{ v.arrivaldate }}</p>
              <!-- <p @click="popupShowHandle(1)">提货时间:{{ v.arrivaldate }}</p> -->
              <p>入库人：{{ v.warehouser_name }}</p>
              <p>实际到库数量：{{ v.actualquantity }}</p>
              <p>创建时间：{{ v.createtime }}</p>
              <div class="paBtn2" v-if="v.processed == -1">异常</div>
              <div class="paBtn1" v-if="v.processed != -1 && v.is_commit == 0" @click="checkShow = true">确认</div>
              <div class="paBtn2" v-if="v.processed != -1 && v.is_commit == 1" @click="onToast('已确认')">
                已确认
              </div>
            </div>
            <!-- <div class="st-list-bottom-xs">
              <router-link :to="'/workOrder/info/' + v.code" class="st-opt-btn">查看详情</router-link>
            </div> -->
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/workOrder/info/' + v.code" class="st-opt-btn">查看详情</router-link>
              </div>
              <div class="st-diyr-btn">
                <a :href="v.orderfile" download class="st-opt-btn">下载文件</a>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-popup v-model="popupShow" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        v-if="stlist[0] && timeType == 0"
        v-model="actualdeliverydate"
        type="datetime"
        title="实际到货时间"
        :min-date="minDate"
        @cancel="popupShow = false"
        @confirm="onconfirm"
      />
      <van-datetime-picker
        v-if="stlist[0] && timeType == 1"
        v-model="arrivaldate"
        type="datetime"
        title="预计到货时间"
        :min-date="minDate"
        @cancel="popupShow = false"
        @confirm="onconfirm"
      />
    </van-popup>

    <!-- 确认工单 -->
    <van-dialog
      class="checkDialog"
      v-model="checkShow"
      title="确认工单"
      showCancelButton
      @cancel="checkShow = false"
      @confirm="onCheckHandle"
    >
      <van-radio-group v-model="checkForm.inspect">
        <van-radio name="1">确认</van-radio>
        <van-radio name="0">异常</van-radio>
      </van-radio-group>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4 }"
        placeholder="请输入异常原因"
        v-model="checkForm.msg"
        v-if="checkForm.inspect == 0"
      >
      </el-input>
    </van-dialog>
  </div>
</template>

<script>
// import axios from "axios";
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      // tabTitle: ["待发货", "待签收", "待付款", "已收款"],
      // cur: 0,
      // oneinfo: {},
      stlist: [],
      actualdeliverydate: 0, // 0 实际提货时间
      arrivaldate: 0, // 1 预计到货时间
      timeType: 0, // 0 -> 实际提货时间  1 -> 预计到货时间
      popupShow: false,
      minDate: new Date(new Date().getFullYear() - 1 + "/01/01"),
      checkShow: false,
      checkForm: {
        code: "",
        msg: "",
        inspect: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    onToast(msg) {
      this.$toast(msg);
    },
    // 分页
    async onLoad() {
      let code = this.$route.params.code;
      let result = await this.$post(this.$api.stGetXiajiagongdanList, { code });
      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist"].push(...result.data);
      // 操作完成
      this.loading = false;
      this.finished = true;
    },
    // 显示时间选择器的回调
    popupShowHandle(type) {
      this.timeType = type;
      this.popupShow = true;
      switch (type) {
        case 0:
          this.actualdeliverydate = this.stlist[0].actualdeliverydate || new Date();
          break;
        case 1:
          this.arrivaldate = this.stlist[0].arrivaldate || new Date();
          break;
        case 2:
          // 提交 提货时间
          // this. = this.stlist[0]. || new Date();
          break;
      }
    },
    // 确定修改时间的回调
    async onconfirm(value) {
      let newTime = +new Date(value);
      let params = {
        code: this.stlist[0].code,
      };
      if (this.timeType == 0) {
        params.actualdeliverydate = newTime / 1000;
      } else if (this.timeType == 1) {
        params.arrivaldate = newTime / 1000;
      }
      // 发起请求

      let result = await this.$post(this.$api.stGetXiajiagongdanEditTime, params);
      this.$toast.success("修改成功");
      // 请求成功的处理
      this.timeType == 0
        ? (this.stlist[0].actualdeliverydate = this.$formatDate(new Date(value), "yyyy年MM月dd日 hh:mm:ss"))
        : (this.stlist[0].arrivaldate = this.$formatDate(new Date(value), "yyyy年MM月dd日 hh:mm:ss"));
      this.popupShow = false;
    },

    // 确认加工单
    async onCheckHandle() {
      let params = this.checkForm;
      if (params.inspect == 0 && params.msg == "") return this.$toast.fail("异常信息不能为空");
      params.code = this.$route.params.code;
      let result = await this.$post(this.$api.stGetXiajiagongdanConfirm, params);
      this.$toast.success("操作成功");

      if (params.inspect == 0) {
        this.stlist = this.stlist.filter((item) => {
          item.processed = -1;
          item.is_commit = 1;
          return item;
        });
      } else if (params.inspect == 1) {
        this.stlist = this.stlist.filter((item) => {
          item.is_commit = 1;
          return item;
        });
      }
      console.log(this.checkForm);
    },
  },
  created() {
    // let type = this.$route.params.type;
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "下架工单列表" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.tab-content-list {
  padding: 0;
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-main {
  position: relative;
}
.paBtn1 {
  padding: 0 12px;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 16px;
  color: #fff;
  background-color: #00baad;
}
.paBtn2 {
  padding: 0 12px;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 16px;
  color: #fff;
  background-color: #677588;
}
.checkDialog {
  padding: 10px 20px;
  .van-radio {
    margin: 10px 0;
  }
}
</style>
